module.exports = __webpack_public_path__ + "assets/img/22_222_big.08bd5ddd.jpg";